export default "__VITE_PUBLIC_ASSET__9cb1c9a7__"